import { Suspense, lazy } from "react";

// The page uses the platform's own page parts, which themselves read this
// package. Loading it on demand keeps the package entry free of that circle.
const Page = lazy(() => import("./AuditPage").then((m) => ({ default: m.AuditPage })));

export const AuditRoute = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

// A tab of the Organization page, in place of its Activity tab.
export const auditTab = {
  after: "sso",
  key: "audit",
  label: "Audit log",
  path: "/audit",
  component: AuditRoute,
  when: "admin",
  replaces: "activity",
};
